export default __webpack_public_path__ + "static/media/notes-icn.2ed7cde2.svg";